import axios from "utils/axios";
import { routes } from "api/routes";

export const apiAnalyzePredictions = async (params) => {
  const { data } = await axios.post(routes.analyzePredictions, params);
  return data;
};

export const apiFetchPredictionsMultipleModels = async (formData) => {
  const { data } = await axios.post(
    routes.getPredictionsMultipleModels,
    formData,
  );
  return data;
};

// Strategies Explorer: rows stream on socket `uuid`; resolves with the run
// summary { tested, total, sent, truncated, cancelled, durationMs }
export const apiRunStrategiesExplorer = async (formData) => {
  const { data } = await axios.post(routes.strategiesExplorer, formData);
  return data;
};

export const apiCancelStrategiesExplorer = async (uuid) => {
  await axios.post(routes.cancelStrategiesExplorer, { uuid });
};

export const apiGetSymbolRecommendations = async (
  symbol,
  startDate,
  endDate,
  returnDict = false,
) => {
  const { data } = await axios.get(routes.getSymbolRecommendations, {
    params: { symbol, startDate, endDate, returnDict },
  });
  return data;
};

export const apiEvaluateBuySellPolarity = async (formData) => {
  const { data } = await axios.post(routes.evaluateBuySellPolarity, formData);
  return data;
};

// Server-side backtest -- computes the same day-by-day engine used by
// startBacktest (BacktestStrategy.js), optionally driving it minute-by-minute
// against candles_1m for intraday take profit / stop loss / trailing take
// profit. `signal` lets the caller abort a superseded request (settings
// change while a previous run is still in flight).
export const apiRunBacktest = async (formData, signal) => {
  const { data } = await axios.post(routes.runBacktest, formData, { signal });
  return data;
};

export const apiBacktestHealth = async (formData, signal) => {
  const { data } = await axios.post(routes.backtestHealth, formData, {
    signal,
  });
  return data;
};

// Server-side options-signal-quality analysis (mirrors the AiOptionsAnalysis
// client engine, moved server-side so the full predictionsTable never has to
// cross the wire -- see api/predictions/options-signal-engine.js).
export const apiAnalyzeOptionsSignals = async (formData, signal) => {
  const { data } = await axios.post(routes.analyzeOptionsSignals, formData, {
    signal,
  });
  return data;
};

// Real-prices options portfolio backtest -- the server generates the signals,
// prices them off the historical option chain in ClickHouse and runs the
// capital simulation; the response is just the result (equity curve, trade
// log, stats). Blocks until done (no job queue yet).
export const apiSimulateOptionsPortfolio = async (formData, signal) => {
  const { data } = await axios.post(routes.simulateOptionsPortfolio, formData, {
    signal,
  });
  return data;
};

// Bulk symbol x model options-signal ranking -- backend streams partial
// results back over socket.io on `formData.uuid` as it computes them (same
// pattern as apiRunStrategiesExplorer); this call just resolves once the
// whole run is done.
export const apiSearchOptionsLeaderboard = async (formData) => {
  const { data } = await axios.post(routes.searchOptionsLeaderboard, formData);
  return data;
};
